/** P-10 — patient order list. */

import { useInfiniteQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";

import { listMyOrders } from "../../api/orders";
import { OrderStatusBadge } from "../../components/OrderStatusBadge";

export function Orders() {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
    queryKey: ["my-orders"],
    queryFn: ({ pageParam }) => listMyOrders(pageParam),
    initialPageParam: 1,
    getNextPageParam: (last) => (last.has_more ? last.page + 1 : undefined),
  });
  const rows = data?.pages.flatMap((p) => p.data) ?? [];

  return (
    <div className="space-y-5">
      <div>
        <h2 className="text-lg font-semibold">Orders</h2>
        <p className="text-sm text-gray-500">Your prescription orders.</p>
      </div>

      <div className="space-y-3">
        {rows.map((o) => (
          <Link key={o.id} to={`/patient/orders/${o.id}`} className="block rounded-xl border bg-white p-4 shadow-xs transition hover:border-brand">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <OrderStatusBadge code={o.status_code} label={o.status_label} />
                <span className="font-medium">{o.line_count} item{o.line_count === 1 ? "" : "s"}</span>
              </div>
              <span className="text-sm font-medium">
                {o.pricing_published_at || Number(o.final_amount) > 0 ? (
                  `₹${o.final_amount}`
                ) : (
                  <span className="font-normal text-gray-500">Waiting for pricing</span>
                )}
              </span>
            </div>
            <div className="mt-1 flex flex-wrap items-center gap-x-2 text-xs text-gray-400">
              <span className="font-mono text-gray-500">{o.order_id}</span>
              <span>Placed {new Date(o.created_at).toLocaleString()}</span>
            </div>
          </Link>
        ))}
        {rows.length === 0 && <p className="text-sm text-gray-400">No orders yet.</p>}
        {hasNextPage && (
          <button onClick={() => fetchNextPage()} disabled={isFetchingNextPage} className="text-sm text-brand hover:underline">
            {isFetchingNextPage ? "Loading…" : "Load more"}
          </button>
        )}
      </div>
    </div>
  );
}
